import { leaflet } from '../../components/locations/assets/leaflet.js';
import { leafletProviders } from '../../components/locations/assets/leaflet-providers.js';

(function()  {

    'use strict';

    /**
     * Initiates the donations object
     */
    const Locations = function (element) {

        this.element = element;
        this.configuration = element.getElementsByTagName('SCRIPT')[0];

        this.initiateObserver();
    };

    /**
     * Start observing
     */
    Locations.prototype.initiateObserver = function () {

        const configuration = JSON.parse(this.configuration.textContent);

        let map = L.map('map');
        map.setView([configuration.map.latitude, configuration.map.longitude], configuration.map.zoom);

        for (const project of configuration.projects) {

            let icon = L.divIcon({ iconSize: [40, 40], className: 'location', html: '<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10 4.60938C12.9724 4.60938 15.3906 7.02759 15.3906 10C15.3906 12.9724 12.9724 15.3906 10 15.3906C7.02759 15.3906 4.60938 12.9724 4.60938 10C4.60938 7.02759 7.02759 4.60938 10 4.60938ZM10 13.8281C12.1107 13.8281 13.8281 12.1107 13.8281 10C13.8281 7.88925 12.1107 6.17188 10 6.17188C7.88925 6.17188 6.17188 7.88925 6.17188 10C6.17188 12.1107 7.88925 13.8281 10 13.8281ZM10.7812 2.31766V0.78125C10.7812 0.349731 10.4315 0 10 0C9.56848 0 9.21875 0.349731 9.21875 0.78125V2.31766C9.21875 2.74918 9.56848 3.09891 10 3.09891C10.4315 3.09891 10.7812 2.74918 10.7812 2.31766ZM9.21875 17.6823V19.2188C9.21875 19.6503 9.56848 20 10 20C10.4315 20 10.7812 19.6503 10.7812 19.2188V17.6823C10.7812 17.2508 10.4315 16.9011 10 16.9011C9.56848 16.9011 9.21875 17.2508 9.21875 17.6823ZM0 10C0 10.4315 0.349731 10.7812 0.78125 10.7812H2.31766C2.74918 10.7812 3.09891 10.4315 3.09891 10C3.09891 9.56848 2.74918 9.21875 2.31766 9.21875H0.78125C0.349731 9.21875 0 9.56848 0 10ZM17.6823 10.7812H19.2188C19.6503 10.7812 20 10.4315 20 10C20 9.56848 19.6503 9.21875 19.2188 9.21875H17.6823C17.2508 9.21875 16.9011 9.56848 16.9011 10C16.9011 10.4315 17.2508 10.7812 17.6823 10.7812ZM5.12024 5.12024C5.42542 4.81506 5.42542 4.32037 5.12024 4.01535L4.03381 2.92892C3.72864 2.62375 3.23395 2.62375 2.92892 2.92892C2.6239 3.23395 2.62375 3.72864 2.92892 4.03381L4.01535 5.12024C4.32053 5.42542 4.81522 5.42526 5.12024 5.12024ZM14.8798 14.8798C14.5746 15.1849 14.5746 15.6796 14.8798 15.9846L15.9662 17.0711C16.2714 17.3763 16.7661 17.3761 17.0711 17.0711C17.3763 16.7661 17.3763 16.2714 17.0711 15.9662L15.9846 14.8798C15.6795 14.5746 15.1848 14.5746 14.8798 14.8798ZM2.92892 15.9662C2.62375 16.2714 2.62375 16.7661 2.92892 17.0711C3.23395 17.3761 3.72879 17.3761 4.03381 17.0711L5.12024 15.9846C5.42542 15.6795 5.42542 15.1848 5.12024 14.8798C4.81506 14.5746 4.32037 14.5746 4.01535 14.8798L2.92892 15.9662ZM17.0711 4.03381C17.3763 3.72864 17.3763 3.23395 17.0711 2.92892C16.7661 2.6239 16.2714 2.6239 15.9662 2.92892L14.8798 4.01535C14.5746 4.32053 14.5746 4.81522 14.8798 5.12024C15.1849 5.42542 15.6796 5.42526 15.9846 5.12024L17.0711 4.03381Z"></path></svg>'});

            let content = `
                <p>${project.title }</p>
                <p>${project.excerpt }</p>
                <a href="${ project.link }">Mehr erfahren</a>`;

            let marker = L.marker([project.location.latitude, project.location.longitude], { icon: icon })
            marker.bindPopup(content).openPopup();
            marker.addTo(map);
        }

        let layer = L.tileLayer('https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png', { attribution: '&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> &copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' })
        layer.addTo(map);
    };

    const locationss = document.getElementsByClassName('js-locations');

    for (const locations of locationss) {
        new Locations(locations);
    }

}());